import { useTranslation } from 'react-i18next';

import { DataItem, NgButtonNavLink } from '@/ui';
import { humanizeDate } from '@ngsos/portal-core/time';
import { incidentDetailRoute } from '@/features/shared/routes';
import type { IncidentListRow } from '@ngsos/portal-core/incidents';
import { MarkerHeader } from './MarkerHeader';

export type IncidentMarkerDetailTemplateProps = {
  item: IncidentListRow;
};

export function IncidentMarkerDetailTemplate({ item }: IncidentMarkerDetailTemplateProps) {
  const { t, i18n } = useTranslation();

  return (
    <div className="d-flex flex-column gap-2" style={{ width: 300 }}>
      <MarkerHeader title={item.title} iconUrl="/Images/Icons/map-incident.svg" />

      <DataItem title={t('Label_UpdateTime')} value={humanizeDate(item.createdAtUtc, i18n.language || 'en')} />

      <div className="d-flex justify-content-center gap-2">
        <NgButtonNavLink to={incidentDetailRoute(item.id)} size="small">
          {t('Button_GoToIncident')}
        </NgButtonNavLink>
      </div>
    </div>
  );
}
